import { httpGetAssetsByAssetIdFormats } from '@iconik-io/iconik-api/src/services/files';
import { httpGetJobsByJobId } from '@iconik-io/iconik-api/src/services/jobs';
import { httpPostSearch } from '@iconik-io/iconik-api/src/services/search';
import {
  isSearchObjectType,
  OBJECT_TYPE_ASSETS,
  SEARCH_OBJECT_TYPES,
} from '@iconik-io/iconik-api/src/types/object_types';

import type { AppDispatch } from '../../../store/types';
import { getSearchDocument } from '../../../utils/get_search_document';

export const getJob = (jobId: string) => (dispatch: AppDispatch) =>
  dispatch(httpGetJobsByJobId(jobId)).then((response) => {
    const job = response.body;
    const promises: Promise<unknown>[] = [];

    if (
      job.object_type &&
      isSearchObjectType(job.object_type) &&
      job.object_id
    ) {
      promises.push(
        dispatch(
          httpPostSearch(
            getSearchDocument([job.object_id], [...SEARCH_OBJECT_TYPES]),
            { save_search_history: false, per_page: 100 },
          ),
        ),
      );
    }

    if (job.object_type === OBJECT_TYPE_ASSETS && job.object_id) {
      promises.push(dispatch(httpGetAssetsByAssetIdFormats(job.object_id)));
    }

    return Promise.all(promises).then(() => response);
  });
